<template>
  <div class="condition-wrap">
    <div class="condition-title">
      {{ title }}
    </div>
    <ul class="condition-list">
      <li v-if="showUnlimited" :class="['condition-item', { active: null === selected.id }]" @click="handleChoose({ name: '不限', id: null })">
        不限
      </li>
      <li v-for="item in options" :key="item.id" :class="['condition-item', { active: item.id === selected.id }]" @click="handleChoose(item)">
        {{ item.name }}
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { isDef } from '@/utils/common';
export default {
  name: 'BaseConditionSingle',
  props: {
    title: String,
    options: Array,
    value: [String, Number],
    showNear: {
      type: Boolean,
      default: false,
    },
    showUnlimited: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      selected: { name: '不限', id: null },
    };
  },
  computed: {
    ...mapGetters(['webSwitch']),
  },
  watch: {
    value: {
      handler(newVal) {
        if (isDef(newVal)) {
          const idx = this.options.findIndex(item => {
            if (isNaN(newVal * 1)) {
              return item.id === newVal;
            }
            return item.id * 1 === newVal * 1;
          });
          if (idx > -1) {
            this.selected = this.options[idx];
          } else {
            if (this.showNear) {
              this.selected = { name: '附近', id: 0 };
            } else {
              this.selected = { name: '不限', id: null };
            }
          }
        } else {
          this.selected = { name: '不限', id: null };
        }
      },
      immediate: true,
    },
  },
  methods: {
    handleChoose(item) {
      this.selected = item;
      this.$emit('input', item.id);
      this.$emit('change', item);
    },
  },
};
</script>

<style lang="less" scoped>
.condition-wrap {
  padding: 0 40px;
  .condition-title {
    padding: 20px 0 40px;
    font-size: 30px;
    font-weight: 600;
    color: #333;
  }

  .condition-list {
    display: flex;
    flex-wrap: wrap;

    .condition-item {
      width: calc((100% - 20px * 2) / 3);
      height: 80px;
      background: #f5f5f5;
      border-radius: 8px;
      margin: 0 20px 20px 0;
      padding: 0 20px;
      line-height: 80px;
      text-align: center;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 28px;

      &:nth-child(3n) {
        margin-right: 0;
      }

      &.active {
        background: #ffece5;
        color: #e84c3d;
      }
    }
  }
}
</style>
